import React from 'react'
import { Modal } from '../../../../views/components'
import styles from './RemoveMembershipModal.module.scss'

export type TRemoveTarget = {
  userId: string
  agencyId: string
  /** Who and where, for the confirmation copy only. */
  userLabel: string
  agencyLabel: string
}

type TProps = {
  target: TRemoveTarget | null
  onCancel: () => void
  onConfirm: (target: TRemoveTarget) => void
}

const RemoveMembershipModal = ({ target, onCancel, onConfirm }: TProps) => (
  <Modal isOpen={!!target} padding="sm" width="sm" theme="dark" showClose={false}>
    <Modal.Header title="Remove agency access?" />
    <Modal.Body
      actions={[
        { label: 'Yes, remove', onClick: () => target && onConfirm(target) },
        { label: 'Cancel', onClick: onCancel },
      ]}
    >
      {target && (
        <p className={styles.copy}>
          <strong>{target.userLabel}</strong> will no longer be able to switch into{' '}
          <strong>{target.agencyLabel}</strong>. Their account and their other agencies are not touched.
        </p>
      )}
    </Modal.Body>
  </Modal>
)

export default RemoveMembershipModal
